import i18next from 'i18next';
import * as couponActions from './actions/couponActions';
class CouponManager {
  init(getState, dispatch) {
    this.getState = getState;
    this.dispatch = dispatch;

    this.timer = null;
  }

  /* PUBLIC API */

  addBet = (marketId, betId) => {
    const addedBetsCount = this.bets().length;

    if (addedBetsCount) {
      const errors = this.expressCheck(marketId, betId);

      if (errors.length) {
        if (addedBetsCount === 1) {
          this.removeAll();
        } else {
          this.dispatch(couponActions.setErrors(errors.slice(0, 1)));
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.dispatch(couponActions.setErrors([]));
          }, 3000);

          return false;
        }
      }
    }

    return this.dispatch(couponActions.addBet(marketId, betId));
  };

  removeBet = (marketId, betId) => {
    return this.dispatch(couponActions.removeBet(marketId, betId));
  };

  toggleBet = (marketId, betId) => {
    if (this.bets().includes(this.betKey(marketId, betId))) {
      return this.removeBet(marketId, betId);
    } else {
      return this.addBet(marketId, betId);
    }
  };

  removeAll = () => {
    return this.dispatch(couponActions.removeAll());
  };

  closeCoupon = () => {
    return this.dispatch(couponActions.closeCoupon());
  };

  openCoupon = () => {
    return this.dispatch(couponActions.openCoupon());
  };

  setCouponState = (couponState) => {
    return this.dispatch(couponActions.setCouponState(couponState));
  };

  /* PRIVATE */

  expressCheck(marketId, betId) {
    const bets = this.bets();
    const errors = [];
    const eventIds = [];
    const leagues = [];

    /* 1 событие - 1 ставка */
    /* 1 лига - 1 ставка */
    bets.forEach((betKey) => {
      const [mId, bId] = betKey.split('@');
      const bet = this.bet(mId, bId);
      if (bet) {
        eventIds.push(bet.event_id);
        const event = this.event(bet);
        if (event) {
          leagues.push(event.ch_name);
        }
      }
    });

    const newBet = this.bet(marketId, betId);
    if (newBet) {
      const newEventId = newBet.event_id;
      const newEvent = this.event(newBet);
      let newEventLeague = '';
      if (newEvent) {
        newEventLeague = newEvent.ch_name;
      } else {
        errors.push(i18next.t('errors.event_not_found', { id: newEventId }));
      }

      if (eventIds.includes(newEventId) !== false) {
        errors.push(i18next.t('errors.express_different_events'));
      }

      if (leagues.includes(newEventLeague) !== false) {
        errors.push(i18next.t('errors.express_different_leagues'));
      }
    } else {
      errors.push(i18next.t('errors.stake_not_found'));
    }

    return errors;
  }

  betKey = (marketId, betId) => [marketId, betId].join('@');

  bets = () => this.getState().coupon.bets;

  bet = (marketId, betId) => {
    try {
      return this.getState().markets.dict[marketId].bets[betId];
    } catch (e) {
      return null;
    }
  };

  event = (bet) => {
    const state = this.getState();
    const getEvent = (eventId) =>
      state.events['prematch'][eventId] || state.events['live'][eventId];
    return getEvent(bet.event_id);
  };
}

const couponManager = new CouponManager();

export default couponManager;



// WEBPACK FOOTER //
// ./app/couponManager.js